<template>
  <button @click="$emit('click')" class="addFavorite" :disabled="disabled">
    <icon-star class="icon" :fill="fill"/>
  </button>
</template>

<script>
import { IconStar } from 'Icons';

export default {
  props: {
    disabled: Boolean,
    fill: Boolean,
  },
  components: {
    IconStar,
  },
};
</script>


<style lang="scss" scoped>
.addFavorite {
  background: none;
  text-decoration: none;
  font-weight: 600 !important;
  @include font(12px, $red-color3 !important);
  cursor: pointer;
  border: none;
  outline: none;
  width: 105px;
}
.icon {
  margin: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/uikit/AddFavoriteBtn.vue